<template>
  <highcharts
    ref="chart"
    :options="chartOptions" />
</template>

<script>
import {Chart} from 'highcharts-vue'

export default {
  name: 'Columns',
  components: {
    highcharts: Chart
  },
  props: {
    dataChart: {
      type: Object
    }
  },
  data () {
    return {
    }
  },
  computed: {
    valueType () {
      return {
        'days': ' dias',
        'percent': '%',
        'number': ''
      }[this.dataChart.value_type]
    },
    chartOptions () {
      const _self = this
      return {
        chart: {
          type: 'column',
          height: 320,
          scrollablePlotArea: {
            minWidth: (this.dataChart.categories.length * 100) // 500
          },
          events: {
            click: function (event) {
              const point = this.series[0].searchPoint(event, true)
              _self.expand(point.index)
            }
          },
          style: {
            cursor: 'pointer'
          }
        },
        title: {
          text: null
        },
        xAxis: {
          // min: 0,
          // max: 4,
          crosshair: {
            enable: true
          },
          categories: this.dataChart.categories /* ['Apples', 'Oranges', 'Pears', 'Grapes', 'Bananas'] */
        },
        yAxis: {
          min: 0,
          title: {
            text: this.dataChart.metric_name
          },
          stackLabels: {
            enabled: true,
            cursor: 'pointer'
          }
        },
        tooltip: {
          // pointFormat: '<span style="color:{series.color}">{series.name}</span>: <b>{point.y}</b><br/>',
          shared: true,
          valueSuffix: this.valueType
        },
        plotOptions: {
          column: {
            pointPadding: 0.2,
            borderWidth: 0,
            stacking: 'stream',
            dataLabels: {
              enabled: true,
              // color: '#5cb84a',
              verticalAlign: 'bottom',
              align: 'right',
              x: 45,
              formatter: function () {
                if (this.point.series.name === 'Movido') {
                  const perc = this.point.options.y / this.point.total * 100
                  return `<span style="color:${this.point.color}">${perc.toFixed(1)}%</span>`
                } else {
                  return null // this.point.options.y
                }
              }
            }
          },
          // column: {
          //   stacking: 'normal',
          //   dataLabels: {
          //     enabled: false
          //   }
          // },
          series: {
            point: {
              events: {
                click: (a) => {
                  this.expand(a.point.index)
                }
              }
            }
          }
        },
        legend: {
          // align: "right",
          enabled: true,
          layout: 'horizontal',
          maxHeight: 70
          // margin: 10,
          // useHTML: true,
          // verticalAlign: 'top',
          // x: 0,
          // y: 100
        },
        series: this.dataChart.series.sort((a, b) => {
          return a.name.toLowerCase() > b.name.toLowerCase() ? -1 : 1
        }).map(item => {
          return {
            ...item,
            color: item.name === 'Movido' ? '#5cb84a' : '#434348'
          }
        }) /* [{
            name: 'John',
            data: [5, 3, 4, 7, 2]
        }, {
            name: 'Jane',
            data: [2, 2, 3, 2, 1]
        }, {
            name: 'Joe',
            data: [3, 4, 4, 2, 5]
        }] */
      }
    }
  },
  methods: {
    expand (index) {
      const filters = this.dataChart.filters[index]
      const name = this.dataChart.categories[index]
      this.$emit('expand', { filters, name })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/ReportChart/CustomPipelineConversion.vue